import AiContentGeneratorRoutes from '@/routes/ai-content-generator';
import CampaignRoutes from '@/routes/campaigns';
import CampaignsV2Routes from '@/routes/campaigns-v2';
import ContentStudioRoutes from '@/routes/content-studio';
import CreatorCrmRoutes from '@/routes/creator-crm';
import CreatorProfileRoutes from '@/routes/creator-profile/creatorProfile';
import CreatorsRoutes from '@/routes/creators/CreatorsRoutes';
import NewCampaignsRoutes from '@/routes/new-campaigns';
import OrganizationSettingsRoutes from '@/routes/organization-settings';
import PartnershipsRoutes from '@/routes/partnerships/PartnershipsRoutes';
import PreferenceRoutes from '@/routes/preferences';
import RecruitCrmRoutes from '@/routes/recruit-crm';
import SearchRoutes from '@/routes/search';
import Vetting from '@/routes/vetting';
import {ROUTES} from '@/config/routesConstants';
import CampaignStatisticsTab from '@/views/campaigns/statistics-tab/CampaignStatisticsTab';
import ContentLibrary from '@/views/content-library';
import Home from '@/views/home';
import PricingPage from '@/views/pricing';
import MobileNotSupportedPlaceholder from '@/components/mobile-not-supported-placeholder';

const MAIN_ROUTES_LIST = [
  {name: 'home', path: '/', Component: Home},
  {
    name: 'ai-studio',
    path: '/ai-studio/*',
    Component: AiContentGeneratorRoutes,
  },
  {
    name: 'new-campaigns',
    path: '/new-campaigns/*',
    Component: NewCampaignsRoutes,
  },
  {
    name: 'mobile-not-supported',
    path: ROUTES.MOBILE_NOT_SUPPORTED,
    Component: MobileNotSupportedPlaceholder,
  },
  {
    name: 'pricing',
    path: '/pricing/*',
    Component: PricingPage,
  },
  {
    name: 'preferences',
    path: '/preferences/*',
    Component: PreferenceRoutes,
  },
  {
    name: 'organization-settings',
    path: `${ROUTES.ORGANIZATION_SETTINGS}/*`,
    Component: OrganizationSettingsRoutes,
  },
  {
    name: 'search-creators',
    path: ROUTES.SEARCH,
    Component: SearchRoutes,
  },
  {
    name: 'creator-crm',
    path: `${ROUTES.CREATOR_CRM}/*`,
    Component: CreatorCrmRoutes,
  },
  {
    name: 'recruit-crm',
    path: `${ROUTES.RECRUIT_CRM}/*`,
    Component: RecruitCrmRoutes,
  },
  {
    name: 'list-creators',
    path: `${ROUTES.MY_CREATORS}/*`,
    Component: CreatorsRoutes,
  },
  {
    name: 'creator-profile',
    path: `${ROUTES.CREATOR_PROFILE}/*`,
    Component: CreatorProfileRoutes,
  },
  {
    name: 'content-library',
    path: ROUTES.CONTENT_LIBRARY,
    Component: ContentLibrary,
  },
  {
    name: 'partnerships',
    path: `${ROUTES.PARTNERSHIPS}/*`,
    Component: PartnershipsRoutes,
  },
  {
    name: 'vetting',
    path: `${ROUTES.VETTING}/*`,
    Component: Vetting,
  },
  {
    name: 'campaign-stats-organic',
    path: `${ROUTES.CAMPAIGN_STATS_ORGANIC}`,
    Component: CampaignStatisticsTab,
  },
  {
    name: 'content-studio',
    path: `${ROUTES.CONTENT_LAB}/*`,
    Component: ContentStudioRoutes,
  },
  {
    name: 'campaigns',
    path: `${ROUTES.CAMPAIGNS}/*`,
    Component: CampaignRoutes,
  },
  {
    name: 'campaigns-v2',
    path: `${ROUTES.CAMPAIGNS_V2}/*`,
    Component: CampaignsV2Routes,
  },
];

export default MAIN_ROUTES_LIST;
